import _asyncToGenerator from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { Iphone, Lock, Unlock } from "@element-plus/icons-vue";
import { getSentCode } from "@/servers/login/loginAPI";
export default defineComponent({
  name: "loginDialog",
  setup: function setup() {
    var isDialog = ref(false); //是否显示对话框

    var errMsg = ref(""); //存储登录错误信息

    var isCaptcha = ref(false); //是否显示验证码登录

    var loginName = ref("验证码登录"); //验证码相关数据

    var checkCodeBtn = reactive({
      text: "发送验证码",
      loading: false,
      disabled: false,
      duration: 30,
      timer: null
    });
    var store = useStore(); // const state: any = useState("Login", ["loginResErr"]);

    var formRef = ref();
    /* 验证手机号规则 */

    var checkPhone = function checkPhone(rule, value, callback) {
      //验证手机号的正则表达式
      var regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;

      if (regPhone.test(value)) {
        //合法手机号
        return callback();
      }

      callback(new Error("请输入合法手机号"));
    };
    /* 输入框绑定值 */


    var ruleForm = reactive({
      phone: "",
      password: "",
      captcha: ""
    });
    /* 校验规则 */

    var rules = reactive({
      //手机号
      phone: [{
        required: true,
        message: "请输入手机号",
        trigger: "blur"
      }, {
        validator: checkPhone,
        trigger: "blur"
      }],
      // 密码
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }],
      //验证码
      captcha: [{
        required: true,
        message: "请输入验证码",
        trigger: "blur"
      }]
    });
    /* 验证码倒计时 */

    var getCheckCode = function getCheckCode() {
      // 倒计时期间按钮不能单击
      if (checkCodeBtn.duration !== 30) {
        checkCodeBtn.disabled = true;
      } // 清除掉定时器


      checkCodeBtn.timer && clearInterval(checkCodeBtn.timer); // 开启定时器

      checkCodeBtn.timer = setInterval(function () {
        var tmp = checkCodeBtn.duration--;
        checkCodeBtn.text = "(".concat(tmp, ") \u91CD\u65B0\u53D1\u9001");

        if (tmp <= 0) {
          // 清除掉定时器
          clearInterval(checkCodeBtn.timer);
          checkCodeBtn.duration = 30;
          checkCodeBtn.text = "重新发送"; // 设置按钮可以单击

          checkCodeBtn.disabled = false;
        }
      }, 1000);
    };
    /* 验证码校验 */


    var captchaClick = function captchaClick() {
      var _formRef$value;

      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validateField(["phone"], /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isLogin, isa) {
          var res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (isLogin) {
                    _context.next = 6;
                    break;
                  }

                  getCheckCode();
                  _context.next = 4;
                  return getSentCode(ruleForm.phone);

                case 4:
                  res = _context.sent;
                  errMsg.value = res.message;

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };
    /* 点击登录，校验 */


    var loginClick = function loginClick() {
      var _formRef$value2;

      var ruleInfo = !isCaptcha.value ? {
        phone: ruleForm.phone,
        password: ruleForm.password
      } : {
        phone: ruleForm.phone,
        captcha: ruleForm.captcha
      };
      (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(isLogin) {
          var res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!isLogin) {
                    _context2.next = 11;
                    break;
                  }

                  _context2.prev = 1;
                  _context2.next = 4;
                  return store.dispatch("Login/getPhone", ruleInfo);

                case 4:
                  res = _context2.sent;

                  //登录成功
                  if (res.code == 200) {
                    isDialog.value = false; //关闭对话框

                    location.reload(); //刷新当前页面
                  } else {
                    errMsg.value = res.message || "手机号或密码错误"; //错误提示信息
                  }

                  _context2.next = 11;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](1);
                  errMsg.value = !isCaptcha.value ? "错误次数太多，请稍后再试" : "验证码错误";

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 8]]);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    };
    /* 对话框关闭事件,清空表单验证 */


    var handleDialogClosed = function handleDialogClosed() {
      if (isDialog.value) {
        var _formRef$value3, _formRef$value4;

        (_formRef$value3 = formRef.value) === null || _formRef$value3 === void 0 ? void 0 : _formRef$value3.clearValidate(); //清除表单验证

        (_formRef$value4 = formRef.value) === null || _formRef$value4 === void 0 ? void 0 : _formRef$value4.resetFields(); //清空表单数据

        errMsg.value = ""; //清空登录错误提示
      }
    };
    /* 切换验证码或手机登录 */


    var captchaLoginClick = function captchaLoginClick() {
      var _formRef$value5, _formRef$value6;

      isCaptcha.value = !isCaptcha.value;
      loginName.value = isCaptcha.value ? "手机登录" : "验证码登录";
      (_formRef$value5 = formRef.value) === null || _formRef$value5 === void 0 ? void 0 : _formRef$value5.clearValidate(); //清除表单验证

      (_formRef$value6 = formRef.value) === null || _formRef$value6 === void 0 ? void 0 : _formRef$value6.resetFields(); //清空表单数据

      errMsg.value = ""; //清空错误提示
    };

    return {
      isDialog: isDialog,
      isCaptcha: isCaptcha,
      formRef: formRef,
      rules: rules,
      ruleForm: ruleForm,
      errMsg: errMsg,
      loginName: loginName,
      checkCodeBtn: checkCodeBtn,
      captchaClick: captchaClick,
      loginClick: loginClick,
      handleDialogClosed: handleDialogClosed,
      captchaLoginClick: captchaLoginClick,
      Iphone: Iphone,
      Lock: Lock,
      Unlock: Unlock
    };
  },
  components: {}
});